import React, { Component } from 'react';
import cls from 'classnames';
import { RCEHelpersPropTypes, withRCEHelpers } from '../../rce-helpers-context/index.js';
import { LabeledToggle } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../../../style-inject.es-746bb8ed.js';
import { PollContextPropTypes } from '../../poll-context/types.js';
import { ImageUpload } from '../../image-upload/ImageUpload.js';
import { AddIcon } from '../../../assets/icons/AddIcon.js';
import { withPoll } from '../../poll-context/PollContext.js';
import { RemoveIcon } from '../../../assets/icons/RemoveIcon.js';
import 'prop-types';
import 'react-measure';
import '../../../helpers-d59c72d9.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../../image-upload/types.js';
import '../../../assets/icons/LoaderIcon.js';
import '../../../assets/icons/ReplaceIcon.js';
import 'lodash';

var css_248z = "[dir=ltr] .rEYDE{text-align:left}[dir=rtl] .rEYDE{text-align:right}[dir] .KQec2{border-bottom:1px solid #ededed;padding:0 20px}.KQec2 .UWCtw{font-size:20px;line-height:1.4}[dir] .KQec2 .UWCtw{margin:25px 0 20px}@supports not (contain:inline-size){@media only screen and (max-width:640px){.KQec2{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .KQec2{padding:20px}}}@container (width < 640px){.KQec2{align-items:center;display:flex;flex-direction:row;justify-content:space-between}[dir] .KQec2{padding:20px}}.JtNYg{height:auto;overflow:hidden}.Ej1Ai,.JtNYg{align-items:center;display:flex}.Ej1Ai{flex-direction:row;font-family:inherit;font-size:16px;line-height:1;outline:none}[dir] .Ej1Ai{background:none;border:0;padding:0}.Ej1Ai.l16v9{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.Ej1Ai.sm-dk{color:inherit}.u6r6e{box-sizing:border-box;height:calc(100% - 227px);overflow:scroll;position:absolute;top:127px;width:100%}[dir] .u6r6e{padding:24px}.u6r6e *,.u6r6e :after,.u6r6e :before{box-sizing:inherit}.u6r6e input{box-sizing:border-box}@supports not (contain:inline-size){@media only screen and (max-width:640px){.u6r6e{height:calc(100% - 100px);top:100px}[dir] .u6r6e{padding:20px}}}@container (width < 640px){.u6r6e{height:calc(100% - 100px);top:100px}[dir] .u6r6e{padding:20px}}.UWCtw{color:var(--ricos-settings-text-color,#000);font-size:16px;line-height:1.5}[dir] .UWCtw{margin:0 0 15px}.OiaGP{color:var(--ricos-settings-text-color,#000);font-size:14px;line-height:1.43}[dir] .OiaGP{margin:0 0 5px}.JySi7,._8CVdV,.nXxhG{font-size:14px;line-height:1.43}[dir] .JySi7,[dir] ._8CVdV,[dir] .nXxhG{margin:0 0 5px}[dir] .JySi7{margin:10px 0}.FuH3s{grid-column-gap:10px;grid-template-columns:repeat(3,1fr)}[dir] .FuH3s{margin:10px 0}.W6Xjj{grid-column-gap:10px;grid-auto-rows:1fr;grid-template-columns:repeat(4,1fr)}[dir] .W6Xjj{margin:20px 0}@supports not (contain:inline-size){@media only screen and (max-width:640px){.W6Xjj{grid-template-columns:repeat(3,1fr)}}}@container (width < 640px){.W6Xjj{grid-template-columns:repeat(3,1fr)}}.FxIIQ{align-items:center;display:flex;flex-direction:row;gap:5px}[dir] .FxIIQ{margin:5px 0}.FxIIQ.JkxCX{align-items:start;display:flex;flex-direction:column}[dir] .FxIIQ.JkxCX{margin:10px 0 20px}.FnqxB{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;height:auto}[dir] .FnqxB{margin:0;padding-top:10px}[dir] .Gtpma{margin:5px 0}[dir] .FnqxB:hover:not(._6J9kR){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] ._6J9kR{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}._6J9kR *{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}[dir] .LKvq-{cursor:pointer;margin:15px 0;padding:0}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] .LKvq-{padding-top:0!important}}}@container (width < 640px){[dir] .LKvq-{padding-top:0!important}}.xjB3h{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;flex-direction:column;justify-content:center;width:80%}[dir] .xjB3h{background:transparent}.j7TL8{align-items:center;bottom:0;display:flex;flex-direction:column;justify-content:center;position:fixed;top:0;z-index:8}[dir] .j7TL8{background-color:rgba(0,0,0,.6);cursor:auto}[dir=ltr] .j7TL8,[dir=rtl] .j7TL8{left:0;right:0}.fqNF8{display:flex;justify-content:flex-end;width:100%}[dir=ltr] .fqNF8{border-right:1px solid #ededed;padding-right:15px}[dir=rtl] .fqNF8{border-left:1px solid #ededed;padding-left:15px}.ki88E{max-width:420px;position:absolute;top:77px;width:100%;z-index:2}[dir] .ki88E{background-color:#fff}@supports not (contain:inline-size){@media only screen and (max-width:640px){.ki88E{max-width:100%;top:50px}}}@container (width < 640px){.ki88E{max-width:100%;top:50px}}.S2FUi,._2-bQ2{color:#fff}._2-bQ2{height:126px!important}.S2FUi{height:40px!important;width:40px!important}.hFMa3{font-size:14px}[dir] ._7d7OR{padding:20px}.G7YHu{box-sizing:border-box;flex:1;font-size:14px;line-height:1.7}[dir] .G7YHu{border:0;border-bottom:1px solid #ededed}[dir=ltr] .G7YHu{padding:8px 35px 8px 20px}[dir=rtl] .G7YHu{padding:8px 20px 8px 35px}.ohBZ6{width:100%}[dir] .ohBZ6{padding:15px 20px}.plHVQ{list-style:none}[dir] .plHVQ{margin:0;padding:0}.X88GO{display:flex;flex-direction:row;position:relative}.ZbseM{position:absolute;top:8px}[dir=ltr] .ZbseM{right:10px}[dir=rtl] .ZbseM{left:10px}";
var styles = {"settings_container":"rEYDE","header":"KQec2","title":"UWCtw","header_button_list":"JtNYg","poll_header_button":"Ej1Ai","poll_header_button_primary":"l16v9","poll_header_button_secondary":"sm-dk","section":"u6r6e","subtitle":"OiaGP","sliderWithInput_label":"JySi7","label":"nXxhG","checkbox_label":"_8CVdV","preset_selector":"FuH3s","layout_selector":"W6Xjj","radioGroup":"FxIIQ","radioPanel":"JkxCX","selectionListOption":"FnqxB","selectionListOptionLabel":"Gtpma","selectionListOption_selected":"_6J9kR","labeled_toggle_root":"LKvq-","modal":"xjB3h","overlay":"j7TL8","preview_button":"fqNF8","poll_tab_headers":"ki88E","poll_image":"_2-bQ2","poll_option_image":"S2FUi","poll_add_option":"hFMa3","poll_controls":"_7d7OR","poll_input":"G7YHu","poll_input_title":"ohBZ6","poll_option_list":"plHVQ","poll_option_list_item":"X88GO","poll_icon_remove":"ZbseM"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class EditPollSectionComponent extends Component {
  updateSettings(layout) {
    this.props.updateData({ layout: __spreadValues(__spreadValues({}, this.props.layout), layout) });
  }
  handleInputChange(cb) {
    return (event) => cb(event.target.value);
  }
  handleOptionTitleUpdate(index, option) {
    return (title) => this.props.updatePollOption(index, __spreadProps(__spreadValues({}, option), {
      title
    }));
  }
  handleOptionImageUpdate(index, option) {
    return (mediaId) => this.props.updatePollOption(index, __spreadProps(__spreadValues({}, option), {
      mediaId
    }));
  }
  handleOptionRemove(index) {
    return () => this.props.removeOption(index);
  }
  render() {
    var _a, _b, _c;
    const { poll, addOption, changePollTitle, changePollImage, layout, t } = this.props;
    return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
      "input",
      {
        maxLength: 160,
        className: cls(styles.poll_input, styles.poll_input_title),
        value: poll.title,
        onChange: this.handleInputChange(changePollTitle),
        placeholder: t("Poll_Editor_Question_Placeholder"),
        type: "text"
      }
    ), ((_a = layout.poll) == null ? void 0 : _a.enableImage) && /* @__PURE__ */ React.createElement(
      ImageUpload,
      {
        className: styles.poll_image,
        value: poll.mediaId,
        onChange: changePollImage
      }
    ), /* @__PURE__ */ React.createElement("ul", { className: styles.poll_option_list }, poll.options.map((option, i) => {
      var _a2;
      return /* @__PURE__ */ React.createElement("li", { className: styles.poll_option_list_item, key: option.id || i }, ((_a2 = layout.option) == null ? void 0 : _a2.enableImage) && /* @__PURE__ */ React.createElement(
        ImageUpload,
        {
          disabled: option.count,
          className: styles.poll_option_image,
          value: option.mediaId,
          onChange: this.handleOptionImageUpdate(i, option),
          small: true
        }
      ), /* @__PURE__ */ React.createElement(
        "input",
        {
          disabled: option.count,
          maxLength: 60,
          className: cls(styles.poll_input, this.poll_input_option),
          value: option.title,
          onChange: this.handleInputChange(this.handleOptionTitleUpdate(i, option)),
          placeholder: t("Poll_Editor_Answer_Placeholder"),
          type: "text"
        }
      ), poll.options.length > 1 && /* @__PURE__ */ React.createElement(
        RemoveIcon,
        {
          onClick: this.handleOptionRemove(i),
          className: styles.poll_icon_remove
        }
      ));
    })), /* @__PURE__ */ React.createElement("div", { className: styles.poll_controls }, /* @__PURE__ */ React.createElement(
      "button",
      {
        onClick: addOption,
        className: cls(
          styles.poll_header_button,
          styles.poll_header_button_primary,
          styles.poll_add_option
        ),
        type: "button"
      },
      /* @__PURE__ */ React.createElement(AddIcon, { width: 12, height: 12 }),
      "\xA0",
      t("Poll_Editor_Answer_AddAnswer")
    ), /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Layout_Section_Question_Image"),
        checked: (_b = layout.poll) == null ? void 0 : _b.enableImage,
        onChange: () => {
          var _a2;
          return this.updateSettings({
            poll: __spreadProps(__spreadValues({}, layout.poll), { enableImage: !((_a2 = layout.poll) == null ? void 0 : _a2.enableImage) })
          });
        },
        theme: this.props.theme,
        style: { paddingTop: 20 }
      }
    ), /* @__PURE__ */ React.createElement(
      LabeledToggle,
      {
        label: t("Poll_PollSettings_Tab_Layout_Section_Answers_Image"),
        checked: (_c = layout.option) == null ? void 0 : _c.enableImage,
        onChange: () => {
          var _a2;
          return this.updateSettings({
            option: __spreadProps(__spreadValues({}, layout.option), { enableImage: !((_a2 = layout.option) == null ? void 0 : _a2.enableImage) })
          });
        },
        theme: this.props.theme,
        style: { paddingTop: 20 }
      }
    )));
  }
}
__publicField(EditPollSectionComponent, "propTypes", __spreadValues(__spreadValues({}, PollContextPropTypes), RCEHelpersPropTypes));
const EditPollSection = withPoll(withRCEHelpers(EditPollSectionComponent));

export { EditPollSection };
//# sourceMappingURL=EditPollSection.js.map
